
export const changeOrgType = value => {
  return dispatch => {
    dispatch({
      type: 'ORG_TYPE_CHANGE',
      payload: value
    })
  }
}

export const setSpecialities = (data) => ({
  type: 'SET_SPEC_KODES',
  payload: data
})

export const setSpecId = (id: number) => {
  return dispatch => {
    dispatch({
      type: 'SET_SPEC_ID',
      payload: id
    })
  }
}

export const changeSort = value => {
  return dispatch => {
    dispatch({
      type: 'CHANGE_DISCIPLNE_SORT',
      payload: value
    })
  }
}

export const setSubjs = (data) => ({
  type: 'SET_SUBJS',
  payload: data
})

export const setSubjId = (id: number | null) => {

  return dispatch => {
    dispatch({
      type: 'SET_SUBJ_ID',
      payload: id
    })
  }
}

export const setPimId = (id, isConstructor = false) => dispatch => {
  dispatch({
    type: 'SET_PIM_OPTIONS',
    payload: { id, isConstructor }
  })
}

export const setPimStruct = (pimData) => {
  return dispatch => {
    dispatch({
      type: 'SET_PIM_STRUCT',
      payload: pimData
    })
  }
}

export const changeStructure = value => dispatch => dispatch({ type: 'CHANGE_STRUCTURE', payload: value })